export default __webpack_public_path__ + "static/media/TotalUploads.5081dc3d.svg";